import { BasicHeadCell } from '../../models/BasicTable/BasicTableProps';
import { QuotationProductItem } from '../../models/quotations/Quotations';

export const QUOTE_PRODUCTS_HEAD_CELLS: BasicHeadCell<QuotationProductItem>[] =
    [
        {
            id: 'image',
            disablePadding: true,
            label: 'PRODUCT',
        },
        {
            id: 'name',
            disablePadding: true,
            label: '',
        },
        {
            id: 'quantity',
            disablePadding: false,
            label: 'QUANTITY',
        },
        {
            id: 'net_price',
            disablePadding: false,
            label: 'UNIT_NET_PRICE',
        },
        {
            id: 'margin',
            disablePadding: false,
            label: 'MARGIN',
        },
        {
            id: 'net_price',
            disablePadding: false,
            label: 'NET_PRICE',
        },
        {
            id: 'shopify_variant_id',
            disablePadding: false,
            label: '',
        },
    ];
